import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { QaResolverFeed } from 'app/services/resolution-center.service';

export interface ResolveCenterInput {
	feeds: QaResolverFeed[];
	record: any;
}
@Component({
  selector: 'app-feat-resolution-center',
  templateUrl: './feat-resolution-center.component.html',
  styleUrls: ['./feat-resolution-center.component.css']
})
export class FeatResolutionCenterComponent implements OnInit {

	qaResolverFeeds: QaResolverFeed;

	record: any;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data
	) { }

	ngOnInit() {
		this.qaResolverFeeds = this.data.feeds;
		this.record = this.data.record;
	}

}
